import { useState } from 'react'
import styled from 'styled-components'
import { Flex, Text, ExpandableLabel, LinkExternal, Grid, HelpIcon, useTooltip, Button } from '@pancakeswap/uikit'
import { Box } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const Footer = styled(Flex)`
  width: 100%;
  align-items: center;
  background : #00202F;
  /* background: ${({ theme }) => theme.colors.dropdown}; */
`


const BulletList = styled.ul`
  list-style-type: none;
  margin-top: 8px;
  padding: 0;
  li{
    margin: 0;
    padding: 0;
  }
  li:nth-child(2) {
    margin: 0;
    padding: 0;
    display : flex
  }
  li::before {
    content: '•';
    margin-right: 4px;
    color: ${({ theme }) => theme.colors.textSubtle};
  }
  li::marker {
    font-size: 12px;
  }
`
interface FarmROIData {
    pool?: any,
    setIsExpanded?: any,
    isExpanded?: any,
}

const FarmRoiCalculatorFooter: React.FC<FarmROIData> = ({ pool, isExpanded, setIsExpanded }) => {
    const {
        targetRef: multiplierRef,
        tooltip: multiplierTooltip,
        tooltipVisible: multiplierTooltipVisible,
    } = useTooltip(
        <>
            <Text>

                The Multiplier represents the proportion of CAKE rewards each farm receives, as a proportion of the CAKE produced each block.

            </Text>
            <Text my="24px">
                {('For example, if a 1x farm received 1 CAKE per block, a 40x farm would receive 40 CAKE per block.')}
            </Text>
            <Text>This amount is already included in all APR calculations for the farm.</Text>
        </>,
        { placement: 'top-end', tooltipOffset: [20, 10] },
    )


    return (
        <Footer p="16px" flexDirection="column">
            <Box sx={{ display: 'flex', ...(isExpanded && { pb: 2 }), alignItems: 'center', color: "#00FED9", cursor: 'pointer' }} onClick={() => setIsExpanded((prev) => !prev)}>
                {isExpanded ? ('Hide') : ('Details')}
                {isExpanded ? <ExpandMoreIcon sx={{ width: '20px', transform: 'rotate(180deg)' }} /> : <ExpandMoreIcon sx={{ width: '20px' }} />}
            </Box>
            {isExpanded && (
                <Box px="8px">
                    <Grid gridTemplateColumns="2.5fr 1fr" gridRowGap="8px" gridTemplateRows={`repeat(}, auto)`}>

                        {/* <>
                            <Text color="#B1B3CB" small>
                                {('APR (incl. LP rewards)')}
                            </Text>
                            <Text small color='white' textAlign="right" bold>
                                123%
                            </Text>
                        </> */}

                        <Text color="#B1B3CB" small>
                            {('APY')}
                        </Text>
                        <Text small color='white' textAlign="right">
                            {/* {(pool.apy).toString()}% */}
                            123
                        </Text>

                    </Grid>
                    <BulletList>
                        <li>
                            <Text fontSize="12px" textAlign="center" color="#B1B3CB" display="inline" lineHeight={1.1}>
                                {('Calculated based on current rates.')}
                            </Text>
                        </li>

                        <li>
                            <Text fontSize="12px" textAlign="start" mt="6px" color="#B1B3CB" display="block" lineHeight={1.1}>
                                All figures are estimates provided for your convenience only, and by no means represent guaranteed returns.
                            </Text>
                        </li>

                    </BulletList>
                    <Flex justifyContent="center" mt="16px">
                        <LinkExternal color="#00FED9">Get DRIVENx</LinkExternal>
                    </Flex>
                </Box>
            )}
        </Footer>
    )
}

export default FarmRoiCalculatorFooter